import swal from 'sweetalert'

class Dialog {
	static alert(intl,options) {
		swal({
			title: options && options.title ? options.title : intl.formatMessage({ id: 'dialog.errors.error_interno_del_sistema.', defaultMessage: 'Error interno del sistema.' }),
			text: options && options.text ? options.text : intl.formatMessage({ id: 'dialog.errors.contacte_al_administrador', defaultMessage: 'Contacte al administrador.' }),
			icon: options && options.icon ? options.icon : "error",
			buttons: {
				confirm: {
					text: intl.formatMessage({ id: 'dialog.errors.button_aceptar', defaultMessage: 'Aceptar' }),
					value: true,
					visible: true,
					className: "btn btn-primary",
					closeModal: true
				}
			}
		});
	}

	static confirm(intl, options, onConfirm, onCancel) {
		swal({
			title: options && options.title ? options.title : '',
			text: options && options.text ? options.text : '',
			icon: options && options.icon ? options.icon : 'warning',
			buttons: {
				cancel: {
					text: options && options.cancelText ? options.cancelText : intl.formatMessage({ id: 'dialog.button.cancelar', defaultMessage: 'Cancelar' }),
					value: null,
					visible: true,
					className: "btn btn-secondary",
					closeModal: true,
				},
				confirm: {
					text: options && options.confirmText ? options.confirmText : intl.formatMessage({ id: 'dialog.button.aceptar', defaultMessage: 'Aceptar' }),
					value: true,
					visible: true,
					className: "btn btn-primary",
					closeModal: true,
				},
			},
		}).then((value) => {
			if (value && onConfirm) {
				onConfirm();
			} else if (!value && onCancel) {
				onCancel();
			}
		});
	}
}

export default Dialog;